// AI-CONTEXT: See docs/features/participation-ladder.md
import { PAID_WORK_ACTIVITY } from './participationOptions'

// Builds a readable situation label from the current activity, its branch
// detail (hours band / volunteer hours) and an optional benefit.
const getSituationLabel = (profile = {}) => {
    const { mainActivity, benefitType } = profile
    if (!mainActivity) return ''

    const benefitSuffix = benefitType && benefitType !== 'Geen' ? ` + ${benefitType}` : ''

    if (mainActivity === PAID_WORK_ACTIVITY) {
        const band = profile.hoursBand ? ` / ${profile.hoursBand}` : ''
        return `Werk${band}${benefitSuffix}`
    }

    if (mainActivity === 'Vrijwilligerswerk') {
        const hours = Number(profile.volunteerHoursPerWeek) || 0
        return `Vrijwilligerswerk / ${hours} u/w${benefitSuffix}`
    }

    return `${mainActivity}${benefitSuffix}`
}

export default getSituationLabel
